import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
const { apiFetch } = window.wp

const MARKER_SVG_OPEN = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="8" viewBox="0 0 20 8" fill="none">
  <path d="M18.8333 6.28767L12.1916 2.45311C11.0944 1.81962 9.75785 1.82477 8.66058 2.4471L2 6.29199" stroke="#1C1E1D" stroke-width="2.11469" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="7" viewBox="0 0 20 7" fill="none">
  <path d="M2.00069 1.2924L8.64235 5.12697C9.73959 5.76046 11.0761 5.75531 12.1734 5.13298L18.834 1.28809" stroke="#1C1E1D" stroke-width="2.11469" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export class ProductSpecs extends LitElement {
	static properties = {
		open: { type: Boolean },
	}

	static styles = css`
		:host {
			display: block;
		}
		details {
			background-color: #fafafa;
			border-radius: 8px;
			margin-top: 24px;
		}
		summary {
			color: var(--Typography-Headings, #1c1e1d);
			background-color: #e9edf2;
			/* Desktop/headings/h6 */
			font-family: Exo;
			font-size: 16px;
			font-style: normal;
			font-weight: 900;
			line-height: 120%; /* 19.2px */
			display: flex;
			justify-content: space-between;
      padding: 23px 22px 22px 23px;
			border-radius: 8px;

		}
		summary::marker {
			display: none;
		}

    .specs-content{
			border-radius: 8px;

    }
    
	`

	constructor() {
		super()
		this.open = false
	}

	render() {
		return html`
			<details @toggle="${() => (this.open = !this.open)}">
				<summary>
					<span>Visa produktspecifikationer</span
					><i> 
          ${this.open ? unsafeHTML(MARKER_SVG_OPEN) : unsafeHTML(MARKER_SVG)} </i>
				</summary>
				<div class="specs-content">
					<slot name="specs"></slot>
				</div>
			</details>
		`
	}
}
